import axios from 'axios'
import { saveAs } from 'file-saver'
import { getAccessTokenPromise } from '..'

// TTP report API: the purchase report files are generated server-side.
const base = () => `${process.env.REACT_APP_BASE_URL_PUBLIC}/ttp-report-api/ttp/reports`

export type TtpReportParams = {
    mill: number
    /** YYYY-MM-DD, inclusive. */
    from: string
    to: string
}

async function authHeaders() {
    return { 'Authorization': `Bearer ${await getAccessTokenPromise()}` }
}

// Only readable when the API lists Content-Disposition in Access-Control-Expose-Headers.
function fileNameFrom(contentDisposition?: string): string | undefined {
    const match = contentDisposition?.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i)
    return match ? decodeURIComponent(match[1]) : undefined
}

// `png` is only accepted by monthly.pdf, which embeds it as the supply map.
export async function downloadTtpReport(path: string, params: TtpReportParams, fallbackName: string, png?: Blob): Promise<void> {
    const url = `${base()}/${path}`
    const headers = await authHeaders()
    const res = png
        ? await axios.post(url, png, { params, responseType: 'blob', withCredentials: false, headers: { ...headers, 'Content-Type': 'image/png' } })
        : await axios.get(url, { params, responseType: 'blob', withCredentials: false, headers })
    saveAs(res.data, fileNameFrom(res.headers['content-disposition']) ?? fallbackName)
}

// With responseType 'blob' the error body is a Blob too, so read it before unwrapping.
export async function ttpReportError(e: any): Promise<string> {
    const data = e?.response?.data
    if (data instanceof Blob) {
        const text = await data.text()
        try {
            return JSON.parse(text)?.error ?? text
        } catch {
            return text || e?.message
        }
    }
    return data?.error ?? e?.message ?? 'request failed'
}
